import { Component, Inject, OnDestroy, OnInit } from '@angular/core';

import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { DOCUMENT } from '@angular/common';
import { ApplicationSecurityService } from '../../../components/application-security/services/application-security.service';

interface IWhiteListOrBlackListIPModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-whitelist-blacklist',
  templateUrl: './whitelistOrBlackListIpAddress.component.html',
  styleUrls: ['./whitelistOrBlackListIpAddress.component.scss'],
})
export class WhiteListOrBlackListIpModalComponent implements OnInit, OnDestroy {
  constructor(
    public modal: SuiModal<IWhiteListOrBlackListIPModalContext, void, void>,
    @Inject(DOCUMENT) private document,
    private applicationSecuritySvc: ApplicationSecurityService
  ) {}
  pending: boolean;

  ngOnInit() {
    this.document.body.classList.remove('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  operation() {
    this.pending = true;
    if (this.modal.context.data.operation === 'whitelist') {
      this.applicationSecuritySvc
        .whiteListIP(this.modal.context.data.blacklistedIpId)
        .subscribe(
          (res) => {
            this.pending = false;
            let modalData: any = {
              success: true,
              message: 'IP whitelisted successfuly',
            };
            this.modal.approve(modalData);
          },
          (error) => {
            let modalData: any = {
              success: false,
              message: error.error.errorMessage
                ? error.error.errorMessage
                : error.error.error
                ? error.error.error
                : error.error
                ? error.error
                : error,
            };
            this.modal.deny(modalData);
            this.pending = false;
          }
        );
    } else {
      let body = {
        ipRange: this.modal.context.data.ipAddress,
        reason: '',
      };
      this.applicationSecuritySvc.blackListIP({ body }).subscribe(
        (res) => {
          this.pending = false;
          let modalData: any = {
            success: true,
            message: 'IP blacklisted successfuly',
          };
          this.modal.approve(modalData);
        },
        (error) => {
          let modalData: any = {
            success: false,
            message: error.error.errorMessage
              ? error.error.errorMessage
              : error.error.error
              ? error.error.error
              : error.error
              ? error.error
              : error,
          };
          this.modal.deny(modalData);
          this.pending = false;
        }
      );
    }
  }
}

export class WhiteListOrBlackListIpModal extends ComponentModalConfig<
  IWhiteListOrBlackListIPModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(WhiteListOrBlackListIpModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
